export const FLAG_GOOGLE_AUTH = 'zezam_creator_app_social_auth_google'
export const FLAG_GITHUB_AUTH = 'zezam_creator_app_social_auth_github'
export const FLAG_FACEBOOK_AUTH = 'zezam_creator_app_social_auth_facebook'
export const FLAG_SEAMLESS_AUTH = 'zezam_creator_app_seamless_auth'

export const FLAG_FACEBOOK_MESSAGE = 'zezam_creator_app_facebook_error_message'
